import { ComponentProps } from "react";

import Button from "@components/buttons/Button";
import styles from "@components/buttons/CircleButton.module.css";
import IconBase from "@components/text/IconBase";
import { IconName } from "@utils/iconUtils";

type Props = Omit<ComponentProps<typeof Button>, "children" | "resizeOnMobile"> & {
  icon: IconName;
};

const CircleButton = ({ className, icon, ...buttonProps }: Props) => {
  const classNames = ["ion-no-margin", styles.circleButton];
  if (className) classNames.push(className);

  return (
    <Button {...buttonProps} className={classNames.join(" ")} resizeOnMobile={false}>
      <IconBase icon={icon} slot="icon-only" />
    </Button>
  );
};

export default CircleButton;
